import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ActionButton from "../../../components/common/ActionButton";
import ActionHeading from "../../../components/common/ActionHeading";
import Container from "../../../components/common/Container";
import HeaderBar from "../../../components/common/HeaderBar";
import PageHeading from "../../../components/common/PageHeading";
import WebsiteDifferenceFilters from "../../../components/sentinel/WebsiteDifferenceFilters";
import WebsiteDifferencesListing from "../../../components/sentinel/WebsiteDifferencesListing";
import { getLoggedInUser } from "../../../reducers";
import { clearIcon, websiteDifferenceIcon } from "../../../util/icons";
import usePersistedState from "../../../util/persistedState";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  contents: {
    marginBottom: "75px",
  },
}));

const defaultFilter = {
  digitalAssetIds: [],
  statuses: [],
  different: true,
};

const Index = ({ loggedInUser, history }) => {
  const classes = useStyles();
  const [sortBy, setSortBy] = usePersistedState(
    `website-differences-listing-sort-${loggedInUser.email}`,
    {
      field: "orgFriendlyId",
      direction: "asc",
    }
  );
  const [filter, setFilter] = usePersistedState(
    `website-differences-filter-${loggedInUser.email}`,
    defaultFilter,
    ["textSearch"]
  );

  const clearFilter = () => setFilter(defaultFilter);

  const updateFilter = (key, value) => {
    setFilter({
      ...filter,
      [key]: value,
    });
  };

  return (
    <div className={classes.root}>
      <HeaderBar fluid>
        <ActionHeading
          heading={
            <PageHeading
              icon={websiteDifferenceIcon()}
              heading="Website Differences"
            />
          }
          actions={[
            <ActionButton
              key="clearFilter"
              tooltip="Clear filters"
              icon={clearIcon()}
              onClick={clearFilter}
              data-cy="clear-filters-button"
            />,
          ]}
        />
      </HeaderBar>
      <WebsiteDifferenceFilters filter={filter} updateFilter={updateFilter} />
      <Container fluid className={classes.contents}>
        <WebsiteDifferencesListing
          filter={filter}
          clearFilter={clearFilter}
          sortBy={sortBy}
          updateSort={setSortBy}
          history={history}
        />
      </Container>
    </div>
  );
};

Index.propTypes = {
  history: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
};

Index.defaultProps = {
  loggedInUser: null,
};

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});

export default connect(mapStateToProps)(Index);
